import { render, staticRenderFns } from "./cartPentagon.vue?vue&type=template&id=26375768&"
import script from "./cartPentagon.vue?vue&type=script&lang=js&"
export * from "./cartPentagon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports